import { Transition } from '@headlessui/react';
import React from 'react';

const c = {
    popover:
        'absolute left-0 right-0 p-24 rounded-8 s-bg shadow-l overflow-hidden',
    popoverModal: 'my-16',
};

type SearchboxPopoverProps = {
    children?: React.ReactNode;
    className?: string;
    isModal?: boolean;
    isOpen: boolean;
    isStatic?: boolean;
};

export function SearchboxPopover(props: SearchboxPopoverProps) {
    const {
        children,
        className = '',
        isModal = false,
        isOpen,
        isStatic = false,
    } = props;

    if (isStatic) {
        return <div className="my-16">{children}</div>;
    }

    return (
        <Transition
            className="relative z-10"
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
            show={isOpen}
        >
            <div
                hidden={!isOpen}
                className={`${className} ${
                    isModal ? c.popoverModal : c.popover
                }`}
            >
                {children}
            </div>
        </Transition>
    );
}
